import { render, staticRenderFns } from "./tcbgTable.vue?vue&type=template&id=21fed0f0&scoped=true"
import script from "./tcbgTable.vue?vue&type=script&lang=js"
export * from "./tcbgTable.vue?vue&type=script&lang=js"
import style0 from "./tcbgTable.vue?vue&type=style&index=0&id=21fed0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fed0f0",
  null
  
)

export default component.exports